import { render, staticRenderFns } from "./HeaderRegister.vue?vue&type=template&id=34c2ef49&scoped=true&"
var script = {}
import style0 from "./HeaderRegister.vue?vue&type=style&index=0&id=34c2ef49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c2ef49",
  null
  
)

export default component.exports